import { Injectable } from "@angular/core";
import { KYMW1503Model } from "../kymw1503.model";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マーク情報登録サービス
 *
 * @export RegistMarkService
 * @class RegistMarkService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistMarkService extends PlessJsonResponderSub<any> {
  private model: KYMW1503Model;
  private callback: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistMarkService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          condition: {
            MarkCode: this.model.markCode,
            MarkName: this.model.markName,
            MarkGroupCode: this.model.selectedMarkGroup,
            SupplyPromoteMarkDiv: this.model.selectedSupplyPromoteMarkDiv,
            StartOrderCode: this.model.startOrderCode,
            EndOrderCode: this.model.endOrderCode,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistMarkService
   */
  execute(model: KYMW1503Model, f: () => void = null): void {
    this.model = model;
    this.callback = f;
    this.send('registMark', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistMarkService
   */
  success(): void {
    if (this.callback) this.callback();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
